
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";


// mudar entre o ambiente de produção e desenvolvimento
// produção
const firebaseConfig = {
    apiKey: "AIzaSyCd-vCnDJXtjsqoFIy525DCEGg7tbvguCM",
    authDomain: "winners-ai-473119.firebaseapp.com",
    projectId: "winners-ai-473119",
    storageBucket: "winners-ai-473119.firebasestorage.app",
    messagingSenderId: "712108985873",
    appId: "1:712108985873:web:944314ab73cc9a42422bb0",
    measurementId: "G-ZRWZPQLQZN"
};


// desenvolvimento
/*
const firebaseConfig = {
    apiKey: "AIzaSyCnMsawFa6mf-ILMiL9uzWp6PORQmUbWcQ",
    authDomain: "winners-ai-dev.firebaseapp.com",
    projectId: "winners-ai-dev",
    storageBucket: "winners-ai-dev.firebasestorage.app",
    messagingSenderId: "452729552991",
    appId: "1:452729552991:web:c949523a565919bcf19bea"
};
*/


const firebaseApp = initializeApp(firebaseConfig);

const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);
const analytics = getAnalytics(firebaseApp);

export { auth, db, analytics };